import { render, staticRenderFns } from "./DocumentsCapture.vue?vue&type=template&id=8903556c&scoped=true"
import script from "./DocumentsCapture.vue?vue&type=script&lang=js"
export * from "./DocumentsCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8903556c",
  null
  
)

export default component.exports